import { Badge } from 'src/components/atoms/Badge';
import styled from 'styled-components';

export const GraphContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const XAxisTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 100px;
  padding-top: 20px;
`;
export const ContainerTextContainer = styled.div<{
  width: number;
  marginLeft: number;
}>`
  display: flex;
  width: 100%;
  width: ${(props) => `${props.width}px`};
  height: 430px;
  position: absolute;
  justify-content: center;
  align-items: center;
  margin-left: ${(props) => `${props.marginLeft}px`};
`;

export const BarStackedContainer = styled.div`
  padding-left: 20px;
  width: 100%;
`;

export const CustomYBadge = styled(Badge)`
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
  white-space: nowrap;
  text-transform: none;
`;
export const CustomXBadge = styled(Badge)`
  text-transform: none;
`;

export const YAxisTitle = styled.div`
  display: flex;
  max-width: 28px;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  margin-bottom: 20px;
`;

export const BarStackedAndToolTipContainer = styled.div`
  width: 100%;
`;
